import { styled } from 'next-yak'

import * as copy from '../copy'
import * as COLORS from '../../constants/colors'
import * as BREAKPOINTS from '../../constants/breakpoints'

import * as input from './input'

export const InputWrapper = styled(input.ComposedWrapper)`
  width: fit-content;
  height: 50px;
  box-sizing: border-box;

  ${input.Input} {
    padding-left: 0;

    /* HACK: mobile browser shenanigans hack, time inputs have very different behaviors...  */
    min-width: 70px;
    max-width: 90px;

    &::-webkit-calendar-picker-indicator {
      display: none;
    }
  }
`

export const Timezone = styled(copy.S.regular)`
  color: ${COLORS.TEXT_TERTIARY};

  @media screen and ${BREAKPOINTS.TABLET} {
    margin-left: 10px;
  }
`

export const Wrapper = styled.div`
  @media screen and ${BREAKPOINTS.TABLET} {
    display: flex;
    align-items: center;
  }
`
